import { Attribute } from 'state/attribute'

const addActiveSelection = (attribute) => {
  // Ensure parent group is highlighted on selection.
  attribute.group.is.highlighted = true

  // Add attribute to the active selection breadcrumbs
  let selection = Object.assign(
    document.createElement('a'), {
      className: 'applied-filter',
      href: attribute.url,
      id: attribute.id,
      title: attribute.name,
      innerHTML: attribute.nameLeftNav,
      onclick: (event = {}) => {
        MK.events.emit('attribute:toggle', {
          target: attribute,
          property: 'selected',
          value: false
        })

        return false
      }
    }
  )

  Attribute.selections.container.appendChild(selection)
}

MK.events.on('attribute:toggle', (event = {}) => {
  const attribute = event.target

  attribute.is[event.property] = (typeof event.value === 'boolean' ? event.value : !attribute.is[event.property])
  console.log(`DEBUG (attribute.toggle): Toggling ${event.property}: ${attribute.is[event.property]} for ${attribute.name}`, attribute.is)

  attribute.calculateClass()

  if (event.property === 'selected') {
    if (attribute.is.selected) {
      addActiveSelection(attribute)
    } else {
      attribute.checkForRedirects()
      // Remove attribute to the active selection breadcrumbs
      let selection = document.getElementById(attribute.id)
      selection && Attribute.selections.container.removeChild(selection)
    }
  }

  if (attribute.group.is.abbreviated) {
    console.log(`DEBUG (MK.attribute.toggle): --------------------------- ${attribute.group.name} is abbreviated. --------------------------- `)
    attribute.group.is.abbreviated = false
    // attribute.group.updateClasses()
  }

  attribute.group.updateSelections()
})